import { Typography } from '@mui/material';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import { CancelButton, DeleteButton } from '../../../../components/mui/Buttons/Buttons';

/**
 * "Remove these hours?" / "Delete this entry?" - the portal's own dialog and buttons. Opened by the caller (`open` / `setOpen`);
 * `onConfirm` runs the removal and the dialog closes.
 */
export default function ConfirmDialog({ open, setOpen, title, note, confirmLabel = 'Delete', onConfirm, loading = false }) {
  return (
    <GlobalDialog
      title={title}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth="xs"
      content={<Typography>{note}</Typography>}
      actionButton={
        <>
          <CancelButton action={() => setOpen(false)}>Cancel</CancelButton>
          <DeleteButton
            disabled={loading}
            action={() => {
              setOpen(false);
              onConfirm();
            }}
          >
            {confirmLabel}
          </DeleteButton>
        </>
      }
    />
  );
}
